import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_PERMITS } from './vehicleEntityConfigs';

const VehiclePermits = () => <VehicleEntityGridPage config={VEHICLE_PERMITS} />;

export default VehiclePermits;
